import { useEffect, useRef } from "react";

interface GameStreakModalProps {
  onClose?: () => void;
}

export default function GameStreakModal({ onClose }: GameStreakModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handler = () => {
      dialogRef.current?.close();
      onClose?.();
    };

    el.addEventListener("close", handler);

    return () => el.removeEventListener("close", handler);
  }, [onClose]);

  return (
    <dialog
      ref={dialogRef}
      className="fixed inset-0 z-20 m-0 h-screen max-h-none w-screen max-w-none place-items-center bg-[#f2f2f2] p-0 open:grid"
    >
      <game-complete ref={ref} game={"nonograms"}></game-complete>
    </dialog>
  );
}
